import { render, staticRenderFns } from "./PageOpportunities.vue?vue&type=template&id=68247db0"
import script from "./PageOpportunities.vue?vue&type=script&lang=js"
export * from "./PageOpportunities.vue?vue&type=script&lang=js"
import style0 from "./PageOpportunities.vue?vue&type=style&index=0&id=68247db0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports